/**
 * 全屏状态
 */
export type SCREEN_STATE = 'no-full' | 'full';

/**
 * 渲染类型
 */
export enum RENDER_TYPE {
    CANVAS = 1,
    SVG = 2,
    IMAGE = 3,
}

/**
 * 白名单类型
 */
export enum RENDER_HIT_TYPE {
    NONE = 0,
    ENTERPRISE_ID,
    ELEMENT_ID,
    PDF_URL,
}

/**
 * pdf的图片信息
 */
export interface IPdfImages {
    path: string;
    list: string[];
}
